module.exports = __webpack_public_path__ + "img/stock1.e8b1b906.png";